import { BonificoOrderStatus } from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";

export const BONIFICO_ORDER_STATUS_LABELS: Record<BonificoOrderStatus, string> =
  {
    [BonificoOrderStatus.Draft]: "Bozza",
    [BonificoOrderStatus.Discarded]: "Bozza scartata",
    [BonificoOrderStatus.PendingPayment]: "In attesa di pagamento",
    [BonificoOrderStatus.ManuallyHandled]: "Gestito a mano",
    [BonificoOrderStatus.PartiallyPaid]: "Parzialmente pagato",
    [BonificoOrderStatus.AwaitingInvoice]: "Fattura da emettere",
    [BonificoOrderStatus.Paid]: "Pagato",
    [BonificoOrderStatus.Historical]: "Storico",
    [BonificoOrderStatus.Refunded]: "Rimborsato",
    [BonificoOrderStatus.PartiallyRefunded]: "Parz. rimborsato",
  };
